module.exports = __webpack_public_path__ + "img/UM.4d4fa0c2.png";